import { kanopyMenuAdTemplate } from './kanopy-menu-ad-view.html';

const { bowser } = window;

export class KanopyMenuAdView extends Backbone.View {
    isTolinoDevice;
    kanopySignUpUrl;

    constructor({ isTolinoDevice, kanopySignUpUrl }) {
        super(...arguments);

        this.isTolinoDevice = isTolinoDevice;
        this.kanopySignUpUrl = kanopySignUpUrl;

        this.render();
    }

    render() {
        const { mobile, tablet } = bowser;
        const promoteSignUp =
            !mobile && !tablet && !this.inApp && !this.isTolinoDevice;
        const kanopySignUpUrl = promoteSignUp
            ? this.kanopySignUpUrl
            : 'https://www.kanopy.com';

        const view = kanopyMenuAdTemplate({
            kanopySignUpUrl,
            promoteSignUp,
        });
        this.$el.empty().append(view);
    }
}
